/**
 * 客服插件工具函数
 * 用于全局加载Dify客服插件并通过display控制显示
 */

/**
 * 全局加载客服插件（只加载一次）
 * @param {Object} config - 插件配置
 * @param {string} config.token - 插件token
 * @param {Object} config.inputs - 输入变量
 * @param {Object} config.systemVariables - 系统变量
 * @param {Object} config.userVariables - 用户变量
 * @param {Object} config.styles - 样式配置
 */
export function loadChatbotGlobally(config = {}) {
  // 默认配置
  const defaultConfig = {
    token: 'R4oJsHKHPTbXLVmH',
    inputs: {},
    systemVariables: {},
    userVariables: {},
    styles: {
      backgroundColor: '#1C64F2',
      width: '24rem',
      height: '40rem'
    }
  };

  // 合并配置
  const finalConfig = {
    ...defaultConfig,
    ...config,
    inputs: { ...defaultConfig.inputs, ...(config.inputs || {}) },
    systemVariables: { ...defaultConfig.systemVariables, ...(config.systemVariables || {}) },
    userVariables: { ...defaultConfig.userVariables, ...(config.userVariables || {}) },
    styles: { ...defaultConfig.styles, ...(config.styles || {}) }
  };

  // 如果已经加载过，直接返回
  if (window.difyChatbotLoaded) {
    console.log('客服插件已全局加载');
    return;
  }

  // 设置全局配置
  window.difyChatbotConfig = {
    token: finalConfig.token,
    inputs: finalConfig.inputs,
    systemVariables: finalConfig.systemVariables,
    userVariables: finalConfig.userVariables
  };

  // 创建样式标签 - 默认隐藏，通过页面控制显示
  const style = document.createElement('style');
  style.textContent = `
    #dify-chatbot-bubble-button {
      background-color: ${finalConfig.styles.backgroundColor} !important;
      display: none !important; /* 默认隐藏 */
      bottom: 120px !important; /* 上移图标位置 */
    }
    #dify-chatbot-bubble-window {
      width: ${finalConfig.styles.width} !important;
      height: ${finalConfig.styles.height} !important;
    }
    /* 客服插件显示类 */
    .chatbot-visible #dify-chatbot-bubble-button {
      display: block !important;
    }
  `;
  document.head.appendChild(style);

  // 创建脚本标签
  const script = document.createElement('script');
  script.src = 'https://udify.app/embed.min.js';
  script.id = finalConfig.token;
  script.defer = true;

  // 脚本加载完成后的回调
  script.onload = () => {
    window.difyChatbotLoaded = true;
    console.log('客服插件全局加载成功');
  };

  script.onerror = () => {
    console.error('客服插件加载失败');
  };

  // 添加脚本到页面
  document.body.appendChild(script);
}

/**
 * 显示客服插件
 */
export function showChatbot() {
  document.body.classList.add('chatbot-visible');
  console.log('客服插件已显示');
}

/**
 * 隐藏客服插件
 */
export function hideChatbot() {
  document.body.classList.remove('chatbot-visible');
  console.log('客服插件已隐藏');
}

/**
 * 卸载客服插件
 */
export function unloadChatbot() {
  // 移除脚本标签
  const script = document.getElementById('R4oJsHKHPTbXLVmH');
  if (script) {
    script.remove();
  }

  // 移除样式标签
  const styles = document.querySelectorAll('style');
  styles.forEach(style => {
    if (style.textContent.includes('#dify-chatbot-bubble-button')) {
      style.remove();
    }
  });

  // 移除DOM元素
  const button = document.getElementById('dify-chatbot-bubble-button');
  const window_ = document.getElementById('dify-chatbot-bubble-window');

  if (button) button.remove();
  if (window_) window_.remove();

  // 清除全局配置
  delete window.difyChatbotConfig;
  delete window.difyChatbotLoaded;

  console.log('客服插件已卸载');
}

/**
 * 检查客服插件是否已加载
 * @returns {boolean}
 */
export function isChatbotLoaded() {
  return !!window.difyChatbotLoaded;
}
